module.exports = __webpack_public_path__ + "static/media/starIcon.758221b3.svg";